import { Box, Stack } from "@mui/material"

const Divider = () => (
    <Stack spacing={'28px'} alignItems='center' sx={{pl:2.5, pr: 2.5}}>
        <Box sx={{
            width: '100%',
            border: '2px solid',
            borderColor: 'blue.500',
            borderRadius: '2px',
        }} />
        <Box sx={{
            ml: 5,
            mr: 5,
            border: '2px solid',
            borderColor: 'red.500',
            borderRadius: '2px',
            width: '20%',
        }} />
    </Stack>
)

export default Divider